import { GNS } from './GNS.js';

/**
 * GNS.EventThrottle
 * 
 * 高頻度イベント（scroll, resize等）を間引いて
 * パフォーマンスを向上させる
 * 
 * デフォルト: 1秒間に60回（60fps）まで
 */
GNS.EventThrottle = function (a) {
    var b = a.create(a.EventDispatcher),
        c = "EventThrottle";
    return b.init = function (d) {
        b._super.init.call(this), this.duration = d ? d : 1e3 / 60, this.throttleEvent = new a.Event(c);
        var e = this,
            f = e.dispatchEvent;
        this._exec = function (a) {
            return function () {
                f.call(e, a)
            }
        }, this._stock = 0
    }, b.dispatchEvent = function (a) {
        var c = new Date;
        this._timer && clearTimeout(this._timer), c - this._stock >= this.duration ? (a && (this.throttleEvent.params =
            a), b._super.dispatchEvent.call(this, this.throttleEvent), this._stock = c) : this._timer = setTimeout(this
                ._exec(a), this.duration)
    }, b.addEventListener = function (a) {
        b._super.addEventListener.apply(this, [c, a])
    }, b.hasEventListener = function () {
        return b._super.hasEventListener.apply(this, [c])
    }, b.removeEventListener = function (a) {
        b._super.removeEventListener.apply(this, [c, a])
    }, b._self
}(GNS);
